import { useLayerQuery } from "@/v2-backoffice-client/layer/layer.query"
import { useLayerAuthoringStatusesQuery } from "@/v2-backoffice-client/layer/authoring/layer.authoring.status.query"

/**
 * Feature codes that exist in the authoring catalog but haven't landed in
 * this runtime yet (created there but never published, or seed-skipped).
 * Composes the statuses query with the runtime layer query so consumers
 * (the unseeded banner) only need one hook. Self-gated: the statuses query
 * already skips on deployments without a catalog (prod), so this resolves
 * to an empty array there too.
 */
export function useLayerUnseededCodes() {
  const { data: statusData } = useLayerAuthoringStatusesQuery()
  const statuses = statusData?.getLayerAuthoringStatuses

  const { data: layerData } = useLayerQuery({
    skip: !statuses?.length,
  })

  if (!statuses?.length || !layerData?.getLayers) return []

  const runtimeCodes = new Set(
    layerData.getLayers.map((layer) => layer.FeatureCode),
  )
  return statuses
    .filter(
      (status) => !status.IsDeleted && !runtimeCodes.has(status.FeatureCode),
    )
    .map((status) => status.FeatureCode)
}
